import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpg';

function LandingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const createParticle = () => {
      const particle = document.createElement('div');
      particle.className = 'particle';
      particle.style.left = Math.random() * 100 + 'vw';
      particle.style.animationDuration = Math.random() * 3 + 2 + 's';
      document.querySelector('.particles-container')?.appendChild(particle);
      
      setTimeout(() => {
        particle.remove();
      }, 5000);
    };

    const interval = setInterval(createParticle, 200);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false); // Close mobile menu after clicking
    }
  };

  return (
    <div className="relative min-h-screen bg-transparent text-white overflow-hidden">
      <div className="particles-container absolute inset-0" />
      
      {/* Navigation Bar */}
      <nav className="relative z-20 bg-gradient-to-r from-blue-900/80 to-blue-700/80 backdrop-blur-lg border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <div className="text-xl font-bold text-white">Wilcza Wataha</div>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <button onClick={() => scrollToSection('home')} className="text-white hover:text-blue-300 px-3 py-2 rounded-md text-sm font-medium transition-colors">Strona Główna</button>
                <button onClick={() => scrollToSection('about-event')} className="text-white hover:text-blue-300 px-3 py-2 rounded-md text-sm font-medium transition-colors">O Wydarzeniu</button>
                <button onClick={() => scrollToSection('how-to-get')} className="text-white hover:text-blue-300 px-3 py-2 rounded-md text-sm font-medium transition-colors">Jak Dojechać</button>
                <button onClick={() => scrollToSection('schedule')} className="text-white hover:text-blue-300 px-3 py-2 rounded-md text-sm font-medium transition-colors">Harmonogram</button>
                <button onClick={() => scrollToSection('contact')} className="text-white hover:text-blue-300 px-3 py-2 rounded-md text-sm font-medium transition-colors">Kontakt</button>
                <Link to="/login" className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors">Zaloguj się</Link>
              </div>
            </div>
            <div className="md:hidden">
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="text-white hover:text-blue-300 focus:outline-none focus:text-blue-300"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  {mobileMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-blue-900/90 backdrop-blur-lg border-t border-white/10">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <button onClick={() => scrollToSection('home')} className="text-white hover:text-blue-300 block px-3 py-2 rounded-md text-base font-medium transition-colors w-full text-left">Strona Główna</button>
              <button onClick={() => scrollToSection('about-event')} className="text-white hover:text-blue-300 block px-3 py-2 rounded-md text-base font-medium transition-colors w-full text-left">O Wydarzeniu</button>
              <button onClick={() => scrollToSection('how-to-get')} className="text-white hover:text-blue-300 block px-3 py-2 rounded-md text-base font-medium transition-colors w-full text-left">Jak Dojechać</button>
              <button onClick={() => scrollToSection('schedule')} className="text-white hover:text-blue-300 block px-3 py-2 rounded-md text-base font-medium transition-colors w-full text-left">Harmonogram</button>
              <button onClick={() => scrollToSection('contact')} className="text-white hover:text-blue-300 block px-3 py-2 rounded-md text-base font-medium transition-colors w-full text-left">Kontakt</button>
              <Link to="/login" className="bg-blue-600 hover:bg-blue-700 text-white block px-3 py-2 rounded-md text-base font-medium transition-colors">Zaloguj się</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <div id="home" className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4">
        <div className="animate-float">
          <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-blue-500 shadow-2xl mb-8 transform hover:scale-105 transition-transform duration-300">
            <img src={logo} alt="Wilcza Wataha" className="w-full h-full object-cover" />
          </div>
        </div>

        <h1 className="text-6xl font-bold text-white mb-6 text-center animate-fadeIn text-shadow-lg">
          Wilcza Wataha
        </h1>
        
        <p className="text-xl text-blue-200 mb-8 text-center max-w-2xl animate-fadeIn animation-delay-200">
          Dołącz do ekscytującej przygody i stań się częścią naszej watahy! Podejmij wyzwanie i pokaż swoją siłę.
        </p>

        <Link
          to="/login"
          className="animate-fadeIn animation-delay-400 bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-10 rounded-full 
            transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-blue-500/50 text-lg"
        >
          🐺 Rozpocznij Przygodę
        </Link>
      </div>

      {/* Features Section */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-gray-800/70 backdrop-blur-sm rounded-xl border border-blue-500/20 hover:border-blue-500/50 transition-all duration-300 transform hover:scale-105">
            <div className="text-blue-500 text-4xl mb-4">🎯</div>
            <h3 className="text-xl font-bold mb-2">Podejmuj Wyzwania</h3>
            <p className="text-gray-300">Wykonuj zadania i zdobywaj punkty w ekscytującej rywalizacji</p>
          </div>
          <div className="text-center p-6 bg-gray-800/70 backdrop-blur-sm rounded-xl border border-blue-500/20 hover:border-blue-500/50 transition-all duration-300 transform hover:scale-105">
            <div className="text-blue-500 text-4xl mb-4">🏆</div>
            <h3 className="text-xl font-bold mb-2">Wspinaj się w Rankingu</h3>
            <p className="text-gray-300">Rywalizuj z innymi i zajmij miejsce na podium</p>
          </div>
          <div className="text-center p-6 bg-gray-800/70 backdrop-blur-sm rounded-xl border border-blue-500/20 hover:border-blue-500/50 transition-all duration-300 transform hover:scale-105">
            <div className="text-blue-500 text-4xl mb-4">🌟</div>
            <h3 className="text-xl font-bold mb-2">Zdobywaj Nagrody</h3>
            <p className="text-gray-300">Wygrywaj nagrody i uznanie społeczności</p>
          </div>
        </div>
      </div>

      {/* About Event Section */}
      <div id="about-event" className="relative z-10 bg-gray-900/50 backdrop-blur-sm py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-6">O Wydarzeniu</h2>
            <p className="text-xl text-blue-200 max-w-3xl mx-auto">
              Wilcza Wataha to wyjątkowe wydarzenie łączące przygodę, rywalizację i społeczność. 
              Dołącz do nas i odkryj swoje prawdziwe możliwości!
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold text-white mb-4">Co Cię Czeka?</h3>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-center"><span className="text-blue-500 mr-2">•</span> Konkurencje sportowe</li>
                <li className="flex items-center"><span className="text-blue-500 mr-2">•</span> Wspaniałe nagrody</li>
                <li className="flex items-center"><span className="text-blue-500 mr-2">•</span> Rywalizacja w zespołach</li>
                <li className="flex items-center"><span className="text-blue-500 mr-2">•</span> Niezapomniane wspomnienia</li>
              </ul>
            </div>
            <div className="bg-gray-800/50 p-6 rounded-xl">
              <h3 className="text-xl font-bold text-white mb-4">Szczegóły Wydarzenia</h3>
              <div className="space-y-2 text-gray-300">
                <p><strong>Data:</strong> 9 czerwca 2025</p>
                <p><strong>Miejsce:</strong> Aperto Strefa</p>
                <p><strong>Adres:</strong> ul. Chłopickiego 14</p>
                <p><strong>Plan:</strong> Wkrótce więcej szczegółów</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* How to Get There Section */}
      <div id="how-to-get" className="relative z-10 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-6">Jak Dojechać</h2>
            <p className="text-xl text-blue-200">Znajdź najlepszą trasę do Aperto Strefa w Krakowie</p>
          </div>
          
          {/* Recommended Route */}
          <div className="mb-8">
            <div className="bg-green-900/50 backdrop-blur-sm p-6 rounded-xl border border-green-400/30">
              <h3 className="text-xl font-bold text-white mb-4 text-center">🛣️ Zalecana Trasa z Centrum Krakowa</h3>
              <div className="text-gray-300 text-center">
                <p className="mb-2"><strong>Rynek Główny → ul. Floriańska → ul. Basztowa → al. Słowackiego → ul. Chłopickiego 14</strong></p>
                <p className="text-sm text-green-200">Najkrótsza trasa z centrum - ok. 10-15 minut jazdy</p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            <div className="bg-gray-800/70 backdrop-blur-sm p-6 rounded-xl">
              <h3 className="text-xl font-bold text-white mb-4">🚗 Samochodem</h3>
              <p className="text-gray-300 mb-4">
                Z centrum Krakowa: kieruj się al. Słowackiego w stronę Bronowic, następnie skręć w ul. Chłopickiego.
              </p>
              <p className="text-sm text-yellow-200">⚠️ Brak własnego parkingu - dostępne miejsca na ulicy</p>
            </div>
            <div className="bg-gray-800/70 backdrop-blur-sm p-6 rounded-xl">
              <h3 className="text-xl font-bold text-white mb-4">🚌 Komunikacją Publiczną</h3>
              <p className="text-gray-300 mb-4">
                Autobusy: linie 139, 239 do przystanku "Chłopickiego"
              </p>
              <p className="text-sm text-blue-200">Przystanek tuż przy lokalizacji</p>
            </div>
          </div>
          
          <div className="mt-8 text-center">
            <div className="bg-gray-800/50 p-4 rounded-xl inline-block">
              <p className="text-white"><strong>Adres:</strong> Aperto Strefa, ul. Chłopickiego 14, Kraków</p>
              <p className="text-gray-300 mt-2">Dzielnica Bronowice</p>
              <div className="mt-4">
                <a 
                  href="https://www.google.com/maps/dir//ul.+Chłopickiego+14,+Kraków"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md transition-colors"
                >
                  🗺️ Otwórz w Google Maps
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Schedule Section */}
      <div id="schedule" className="relative z-10 bg-gray-900/50 backdrop-blur-sm py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-6">Harmonogram</h2>
            <p className="text-xl text-blue-200">Plan wydarzenia - 9 czerwca 2025</p>
          </div>
          <div className="max-w-2xl mx-auto">
            <div className="bg-gray-800/70 backdrop-blur-sm p-8 rounded-xl text-center">
              <h3 className="text-2xl font-bold text-white mb-6">Plan Wydarzenia</h3>
              <div className="text-gray-300">
                <p className="text-lg mb-4">Szczegółowy harmonogram będzie dostępny wkrótce!</p>
                <p>Śledź nasze social media lub skontaktuj się z nami, aby być na bieżąco z aktualnościami.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact" className="relative z-10 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-xl text-blue-200">Masz pytania? Skontaktuj się z nami!</p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="text-center bg-gray-800/70 backdrop-blur-sm p-6 rounded-xl">
              <div className="text-blue-500 text-4xl mb-4">💻</div>
              <h3 className="text-xl font-bold text-white mb-2">Email</h3>
              <p className="text-gray-300">koder1@interia.pl</p>
            </div>
            <div className="text-center bg-gray-800/70 backdrop-blur-sm p-6 rounded-xl">
              <div className="text-blue-500 text-4xl mb-4">📍</div>
              <h3 className="text-xl font-bold text-white mb-2">Adres</h3>
              <p className="text-gray-300">Aperto Strefa <br />ul. Chłopickiego 14</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="relative z-10 bg-gray-900/80 backdrop-blur-sm border-t border-white/10 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © 2025 Wilcza Wataha. Wszystkie prawa zastrzeżone.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
